import { dataFetch } from '@lib/ggj-utils'

export default {
  // 联盟首页--我的联盟和弹窗信息
  async getIndexMyUnion(params) {
    return dataFetch('/wholesale/api/union/indexMyUnion', params, {
      method: 'get',
    })
  },
  // 联盟首页--联盟列表
  async getIndexUnionList(params) {
    return dataFetch('/wholesale/api/union/rank/unionList', params, {
      method: 'get',
    })
  },
  async checkUnionTab(params) {
    return dataFetch('/wholesale/api/union/checkUnionTab', params, {
      method: 'get',
    })
  },
  // 创建联盟--上传图片
  async uploadPicture(params) {
    return dataFetch('/wholesale/api/union/management/upload/picture', params, {
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  // 创建联盟--创建联盟
  async foundUnion(params) {
    return dataFetch('/wholesale/api/union/foundUnion', params, {
      method: 'post',
    })
  },
  // 联盟PK活动主页
  async getPkHome(params) {
    return dataFetch('/wholesale/api/union/activity/pk/home', params, {
      method: 'get',
    })
  },
  // 联盟PK活动主页-抽奖进度
  async lotteryProgress(params) {
    return dataFetch('/wholesale/api/union/activity/pk/lotteryProgress', params, {
      method: 'get',
    })
  },
  // 联盟PK活动主页-抽奖动作
  async lotteryDraw(params) {
    return dataFetch('/wholesale/api/union/activity/pk/lotteryDraw', params, {
      method: 'get',
    })
  },
  // 用户奖励查询列表批量(希柔PK使用)
  async personalAwardInfoBatch(params) {
    return dataFetch('/lottery-center/api/wheelSurf/personalAwardInfoBatch', params, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },
  // 联盟PK活动主页-20201111插旗能手抽奖动作
  async flagDraw(params) {
    return dataFetch('/wholesale/api/union/activity/pk/flagDraw', params, {
      method: 'get',
    })
  },
  // 20211212抽奖记录
  async queryAccountDrawRecords(params) {
    return dataFetch('/lottery-center/api/platform/queryAccountDrawRecords', params, {
      method: 'get',
    })
  },
  // 20211212单个任务指标总数据
  async queryMissionQuotaData(params) {
    return dataFetch('/member-web/api/cps/mission/queryMissionQuotaData', params, {
      method: 'get',
    })
  },
  // 20211212希柔战队排名
  async queryParticipantRank(params) {
    return dataFetch('/member-web/api/cps/mission/queryParticipantRank', params, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },
  async getTwoActivityDetail(params) {
    return dataFetch('/wholesale/api/union/activity/pk/2/detail', params, {
      method: 'get',
    })
  },
  async getTwoActivityLotteryProgress(params) {
    return dataFetch('/wholesale/api/union/activity/pk/2/lotteryProgress', params, {
      method: 'get',
    })
  },
  async getThreeActivityDetail(params) {
    return dataFetch('/wholesale/api/union/activity/pk/3/detail', params, {
      method: 'get',
    })
  },
  async commitTarget(params) {
    return dataFetch('/wholesale/api/union/activity/pk/2/commitTarget', params, {
      method: 'get',
    })
  },  
  // 联盟PK活动二抽奖动作
  async lotteryDrawTwo(params) {
    return dataFetch('/wholesale/api/union/activity/pk/2/lotteryDraw', params, {
      method: 'get',
    })
  },
}